import { useEffect, useState, type JSX } from "react";
import { useStore } from "../store.js";

function utcClockIso(): string {
  const d = new Date();
  const pad = (n: number) => n.toString().padStart(2, "0");
  return `UTC ${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(
    d.getUTCHours(),
  )}:${pad(d.getUTCMinutes())}`;
}

function fmt(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(2)} M`;
  if (n >= 10_000) return `${(n / 1000).toFixed(1)} k`;
  return new Intl.NumberFormat("en-US").format(n);
}

export function TopBar(): JSX.Element {
  const [now, setNow] = useState(utcClockIso);
  const me = useStore((s) => s.me);

  useEffect(() => {
    const id = setInterval(() => setNow(utcClockIso()), 30_000);
    return () => clearInterval(id);
  }, []);

  const wallet = me?.wallet ?? null;
  const industrialTotal = wallet
    ? Object.values(wallet.industrial).reduce((a, b) => a + (b ?? 0), 0)
    : 0;

  const chips: ReadonlyArray<{
    readonly key: string;
    readonly label: string;
    readonly value: number | null;
  }> = [
    { key: "provisions", label: "PROV", value: wallet ? wallet.stockpile.PROVISIONS ?? 0 : null },
    { key: "treasury", label: "TRSY", value: wallet ? wallet.stockpile.TREASURY ?? 0 : null },
    { key: "reserves", label: "RESV", value: wallet ? wallet.stockpile.RESERVES ?? 0 : null },
    { key: "industrial", label: "MAT", value: wallet ? industrialTotal : null },
    { key: "diamonds", label: "DIA", value: wallet ? wallet.diamonds : null },
  ];

  return (
    <header className="top-bar" aria-label="Top HUD">
      <span className="brand">STAHLFRONT</span>
      <span aria-label="Server time">{now}</span>
      <div
        className="resource-strip"
        aria-busy={wallet === null}
        aria-label={wallet === null ? "Wallet (loading)" : "Wallet"}
      >
        {chips.map((c) =>
          c.value === null ? (
            <span
              key={c.key}
              className="chip"
              data-skeleton="true"
              aria-label={`${c.label} not loaded yet`}
              style={{ minWidth: 78 }}
            >
              {c.label}
            </span>
          ) : (
            <span key={c.key} className="chip" aria-label={`${c.label} ${c.value}`}>
              <span className="chip-label">{c.label}</span>
              <span className="chip-value">{fmt(c.value)}</span>
            </span>
          ),
        )}
      </div>
    </header>
  );
}
